import React from 'react'
import ImageComponent from './image'

class SectionContactComponent extends React.Component {
    render() {
        return (
    <div className="section--fourth" id="contact">
        <div className="section__grid">
            <div className="section__text">
                <h2>Contact us</h2>
                <p>Please, contact us if you have any questions.<br />We will be more than happy to answer.</p>
            </div>
            <div className="section__text u-text-center">
                <form className="section-form" name="contact" method="post" data-netlify-honeypot="bot-field" action="/thank-you-contact/" data-netlify="true">
                <input type="hidden" name="form-name" value="contact" />
                    <p className="u-hidden">
                        <label className="hidden">Don’t fill this out: <input name="bot-field" />
                        </label>
                    </p>
                    <textarea placeholder="message" name="message" required ></textarea>
                    <input type="email" placeholder="email" name="email" required />
                    <div data-netlify-recaptcha></div>
                    <button type="submit" className="c-btn--fourth">Send</button>
                </form>
                
            </div>
        </div>
    </div>
        );
    }
}

export default SectionContactComponent



// WEBPACK FOOTER //
// ./src/components/section-contact.js